import moment from 'moment';
import { BlockScrollStrategy } from '@angular/cdk/overlay';

export class FindTimeResultItem {
    SchedulerID: number;
    SchedulerName: string;
    SchedulerColor: string;
    Date: moment.Moment;
    StartTime: string;
    EndTime: string;
    BranchName: string;
    BusinessName: string;
    BranchID?: number;
    Duration: number;
    WeekDays: boolean[];
    IsTimeSlotFitMoreCustomers: boolean;
    OverlapEventsCount: number;
    PriceListRefID: number;
    AdditionalSlots: number;
    RequestData: string;
    WeekDay: string;
    DateToString: string;
    BranchIDs: number[];
    SchedulerResourceID?: number;
    CityName:string;
    Address:string;

    constructor(obj?: any) {
       
        this.SchedulerID = obj && obj.SchedulerID || 0; // when the first operand is true AND return the second operand
        this.SchedulerName = obj && obj.SchedulerName || '';
        this.SchedulerColor = obj && obj.SchedulerColor || '';
        this.Date = obj && moment(obj.Date) || moment();
        this.StartTime = obj && obj.StartTime || '';
        this.EndTime = obj && obj.EndTime || '';
        this.BranchName = obj && obj.BranchName || '';
        this.BusinessName = obj && obj.BusinessName || '';
        this.BranchID = obj && obj.BranchID || null;
        this.Duration = obj && obj.Duration || 30;
        this.WeekDays = obj && obj.WeekDays || [true, true, true, true, true, true, true];
        this.IsTimeSlotFitMoreCustomers = obj && obj.IsTimeSlotFitMoreCustomers || false;
        this.OverlapEventsCount = obj && obj.OverlapEventsCount || 0;
        this.PriceListRefID = obj && obj.PriceListRefID || 0;
        this.AdditionalSlots = obj && obj.AdditionalSlots || 0;
        this.RequestData = obj && obj.RequestData || null;
        this.WeekDay = obj && obj.WeekDay || null;
        this.DateToString = obj && obj.DateToString || '';
        this.BranchIDs = obj && obj.BranchIDs || [];
        this.SchedulerResourceID = obj && obj.SchedulerResourceID || null; 
        this.CityName = obj && obj.CityName || null;
        this.Address = obj && obj.Address || null;       
    }


    
}